import * as Nutrient from 'types/Ingredient/Detail/Nutrient';

export type Type = Nutrient.Type[];

export function create(): Type {
	return [];
}

export function mapToApi(obj: Type): {
	[key: string]: number;
} {
	const output: {
		[key: string]: number;
	} = {};
	for (const i of obj) {
		output[i.id] = i.value;
	}
	return output;
}

export function merge(firstChoice: Type, secondChoice: Type): Type {
	const output: Type = [...firstChoice];
	const idsOfFirstChoice: string[] = output.map((e) => e.id);
	for (const i of secondChoice) {
		if (!idsOfFirstChoice.includes(i.id)) output.push({ ...i });
	}
	return output;
}
